import { type ReactNode } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui/spinner';
import { EmptyState } from '@/components/ui/empty-state';
import { useAuth } from '@/hooks/use-auth';
import { usePersonalStats } from '@/hooks/use-personal-stats';
import { useApproacherRanking } from '../hooks/use-approacher-ranking';
import { ApproacherStatsContent } from './approacher-stats-content';

export function ApproacherStatsPage(): ReactNode {
  const { collectorId } = useParams<{ collectorId: string }>();
  const { user, isAdmin } = useAuth();
  const targetId = collectorId ?? user?.id;
  const { data, isLoading } = usePersonalStats(targetId);
  const { position, total } = useApproacherRanking(targetId);
  const isViewingOther = collectorId && collectorId !== user?.id;

  if (!isAdmin && isViewingOther) {
    return <Navigate to={`/progress/${user?.id}`} replace />;
  }
  if (isLoading) return <Spinner />;
  if (!data) return <EmptyState title="Sin datos" />;

  return (
    <ApproacherStatsContent
      data={{ ...data, recentLeads: data.leads.slice(0, 10) }}
      targetId={targetId}
      collectorId={collectorId}
      isAdmin={isAdmin}
      position={position}
      totalApproachers={total}
    />
  );
}
